import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {MailEvent} from "../models/Tracking/mail-event.model";
import {MailItem, MailItemSave} from "../models/Tracking/mail-item.model";

@Injectable({providedIn: "root"})
export class MailItemHttpClientService {
    private readonly base = environment.backendBaseUrl;
    private readonly endpoint = "/api/mailitems";
    private readonly fullPath = `${this.base}${this.endpoint}`;
    private readonly delete = `${this.base}${this.endpoint}/deleteItemId`;
    private readonly details = `${this.base}/api/mailItemEvents/getThisApi`;

    constructor(private http: HttpClient) {
    }

    getMailItems = () => this.http.get<Array<MailItem>>(this.fullPath);

    postMailItems = (mailItemToSave: MailItemSave) => this.http
        .post(this.fullPath, mailItemToSave,
            {
                responseType: "text" as "json"
            });

    getMailItemDetails = (barcode: string) =>
        this.http.get<Array<MailEvent>>(this.details + "/" + barcode);


    deleteMailItem = (mailItemId: number) => {
        return this.http.get<string>(this.delete + "/" + mailItemId, {
            responseType: "text" as "json"
        });
    };
}
